import React from 'react';
import { cn } from '../../lib/utils';

type AiGeneratedFigureFrameProps = {
  children: React.ReactNode;
  className?: string;
  /** When false, renders children only (e.g. teacher-uploaded photos). Default true. */
  show?: boolean;
};

/** CSS corner label for AI-created rasters and vector diagrams — not baked into the image. */
export function AiGeneratedFigureFrame({
  children,
  className,
  show = true,
}: AiGeneratedFigureFrameProps) {
  if (!show) return <>{children}</>;

  return (
    <div className={cn('ai-generated-figure relative inline-block max-w-full', className)}>
      {children}
      <span
        className="pointer-events-none absolute bottom-1.5 right-1.5 z-10 rounded bg-black/55 px-1.5 py-0.5 text-[10px] font-medium leading-none tracking-wide text-white"
        aria-hidden
      >
        AI-generated
      </span>
    </div>
  );
}
